<template>
  <div>
    <header1></header1>
    <div class="new_content">
      <div class="new_findPwd_title" style="height: 76px;">
        <router-link to="/findByMobile">手机找回密码</router-link>
        <router-link class="new_findPwd_title_sel" to="/findByEmail">邮箱找回密码</router-link>
        <router-link to="/findByWX">微信找回密码</router-link>
      </div>
      <div class="new_findPwd_main">
        <el-steps :active="active" :space="350" finish-status="success"
          style="margin-left: 100px; margin-bottom: 30px;">
          <el-step title="验证邮箱"></el-step>
          <el-step title="设置密码"></el-step>
          <el-step title="设置成功"></el-step>
        </el-steps>
        <div v-show="active==1">
          <el-form ref="emailForm" :model="emailForm" :rules="emailRules" label-width="100px">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="emailForm.email" style="width: 50%"></el-input>
              <el-button :disabled="sendEmailButtonDisabled" size="small" style="margin-left: 20px;" type="primary"
                @click.native="sendEmailMethod">{{ sendEmailButtonText }}
              </el-button>
            </el-form-item>
            <el-form-item label="验证码" prop="emailCode">
              <el-input v-model="emailForm.emailCode" style="width: 20%"></el-input>
              <a class="yz ml-20 pa" href="javascript:"
                title="①电子邮件偶尔会有延时状况，请耐心等待;②尝试到垃圾邮件里找找看;③若有疑问请拨打客服电话：400-822-2055">没有收到验证码？</a>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button style="width:30%;" type="primary" @click.native="nextEmail">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active==2">
          <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" label-width="100px">
            <el-form-item label="新密码" prop="newPwd">
              <el-input v-model="pwdForm.newPwd" style="width: 50%" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="reNewPwd">
              <el-input v-model="pwdForm.reNewPwd" style="width: 50%" type="password"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button style="width:30%;" type="primary" @click="updatePwd">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active==3">
          <div class="new_content">
            <div style="padding:5% 0;">
              <p class="new_zc_sucess">找回密码成功! </p>
              <p class="new_zc_welcome"><span>{{ userName }}</span>欢迎回来　|　
                <router-link to="/">立即登录</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer1></footer1>
  </div>
</template>
<style scoped>
.new_findPwd_title {
  height: 37px;
  padding-top: 40px;
}

.new_findPwd_title a {
  line-height: 36px;
  display: block;
  float: left;
  width: 130px;
  height: 36px;
  margin-right: 12px;
  text-align: center;
  color: #5F5F5F;
  border: #C9C9C9 1px solid;
  border-bottom: 0px;
}

.new_findPwd_title a.new_findPwd_title_sel {
  color: #FFFFFF;
  border: #1D7A8E 1px solid;
  border-bottom: 0px;
  background: #1D7A8E;
}

.new_fpwx_title {
  font-weight: bold;
  line-height: 40px;
  text-align: left;
  color: #1D7A8E;
}

.new_fpwx_img {
  text-align: center;
}

.new_findPwd_main {
  width: 100%;
  min-height: 340px;
  padding: 40px 0px 0px 0px;
  border: 1px #C9C9C9 solid;
}

p.new_zc_sucess {
  font-size: 30px;
  line-height: 40px;
  width: 245px;
  height: 40px;
  margin: 0px auto;
  padding-left: 36px;
  text-align: left;
  color: #66A000;
  background: url(../assets/img-4/sucess_bg.gif) no-repeat left center;
}

p.new_zc_welcome {
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}

p.new_zc_welcome span, p.new_zc_welcome a {
  color: #FF5300;
}

p.new_zc_welcome a:hover {
  text-decoration: underline
}
</style>

<script>

import header1 from '../components/Header1'
import footer1 from '../components/Footer1'
import sha256 from 'crypto-js/sha256'

import { sendEmail, updatePwd, validateEmailCode, vftelUserEmail } from '../api/api'

export default {
  components: {
    header1,
    footer1
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'))
      } else if (!(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value))) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        vftelUserEmail({email: value}).then((response) => {
          if (response.status == 200) {
            if (response.data.status == 200) {
              callback(new Error(response.data.msg))
            } else {
              callback()
            }
          }
        })
      }
    }
    var validateEmailCodeFuc = (rule, value, callback) => {
      if (!this.emailForm.email) {
        callback(new Error('请先输入邮箱'))
      } else if (!value) {
        callback(new Error('请输入邮箱验证码'))
      } else {
        validateEmailCode({email: this.emailForm.email, code: value}).then((response) => {
          let {data} = response
          if (response.status == 200) {
            if (data.status == 200) {
              callback()
            } else {
              callback(new Error('邮箱验证码错误'))
            }
          }
        })
      }
    }
    
    var validateVpassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.pwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      emailForm: {
        email: '',
        emailCode: '',
        newPwd: '',
        reNewPwd: ''
      },
      pwdForm: {
        newPwd: '',
        reNewPwd: ''
      },
      active: 1,
      userName: '',
      sendEmailButtonDisabled: false,
      smsTime: 0,
      emailRules: {
        email: [
          {required: true, validator: validateEmail, trigger: 'blur'}
        ],
        emailCode: [
          {required: true, validator: validateEmailCodeFuc, trigger: 'blur'}
        ]
      },
      pwdRules: {
        newPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 22, message: '长度在 6 到 22 个字符', trigger: 'blur'}
        ],
        reNewPwd: [
          {validator: validateVpassword, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    sendEmailButtonText() {
      if (this.smsTime > 0) {
        if (!this.sendEmailButtonDisabled) {
          this.sendEmailButtonDisabled = true
        }
        return this.smsTime + 's 后重新获取'
      } else {
        this.sendEmailButtonDisabled = false
        return '获取验证码'
      }
    }
  },
  methods: {
    smsTimer() {
      if (this.smsTime > 0) {
        this.smsTime--
        setTimeout(this.smsTimer, 1000)
      }
    },
    sendEmailMethod() {
      this.$refs.emailForm.validateField('email', error => {
        if (!error) {
          let timestamp = new Date().getTime()
          let sign = sha256(this.emailForm.email + timestamp).toString()
          let param = {
            email: this.emailForm.email,
            bType: 1,
            sign: sign,
            type: 2,
            timestamp: timestamp
          }
          sendEmail(param).then((response) => {
            let {data} = response
            if (response.status == 200) {
              if (data.status == 200) {
                this.$message({
                  message: data.msg,
                  type: 'success'
                })
                this.smsTime = 60
                this.smsTimer()
              } else {
                this.$message({
                  message: data.msg,
                  type: 'warning'
                })
              }
            } else {
              this.$message.error('网络错误！')
            }
          })
        }
      })
    },
    
    nextEmail() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          if (this.active++ > 2) this.active = 0
        } else {
          return false
        }
      })
    },
    
    updatePwd() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          let param = {newPwd: this.pwdForm.newPwd, prama: this.emailForm.email, type: 2}
          updatePwd(param).then((response) => {
            if (response.status == 200) {
              if (response.data.state == 1) {
                this.userName = response.data.userName
                if (this.active++ > 2) this.active = 0
              } else {
                this.$message({
                  message: '操作失败！请刷新后再试！',
                  type: 'warning'
                })
              }
            } else {
              this.$message.error('网络错误！')
            }
          })
        } else {
          return false
        }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/FindByEmail.vue